/* ============================================================================
   LUXURY COLLECTION — Lightweight enhancement script
   - Hero parallax (rAF-throttled, hover-capable devices only)
   - Reveal-on-scroll for editorial sections
   - No layout-shift, GPU transforms only
   ============================================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ----- Reveal on scroll ----- */
  function initReveal() {
    var nodes = document.querySelectorAll('.lux-reveal');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window) || reduceMotion) {
      nodes.forEach(function (n) { n.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ----- Hero parallax ----- */
  function initParallax() {
    if (reduceMotion || !hasFinePointer) return;
    var heroes = document.querySelectorAll('.lux-hero[data-parallax="true"]');
    if (!heroes.length) return;

    var raf = 0;
    var tick = function () {
      raf = 0;
      var scrollY = window.scrollY || window.pageYOffset;
      heroes.forEach(function (hero) {
        var rect = hero.getBoundingClientRect();
        var inView = rect.bottom > 0 && rect.top < window.innerHeight;
        if (!inView) return;
        var depth = parseFloat(hero.getAttribute('data-parallax-depth')) || 0.18;
        var offset = (scrollY - hero.offsetTop) * depth;
        // clamp to avoid revealing edges
        if (offset > 80) offset = 80;
        if (offset < -80) offset = -80;
        hero.style.setProperty('--lux-hero-parallax', offset + 'px');
      });
    };

    window.addEventListener('scroll', function () {
      if (!raf) raf = window.requestAnimationFrame(tick);
    }, { passive: true });

    tick();
  }

  function init() {
    initReveal();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
